import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
//import VueMeta from "vue-meta";

import "./../node_modules/bulma/css/bulma.css";

createApp(App)
  .use(router)
  //.use(VueMeta, { refreshOnceOnNavigation: false })
  .mount("#app");
